import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Route, Switch, Redirect, useHistory, useLocation, useParams } from 'react-router-dom';

import { PERMISSION, PRIVATE_PATH } from '../../../constants';
import { user } from '../../../redux/user';
import utils from '../../../utils/utils';
import SidebarWrapper from '../../../sections/SidebarWrapper';

import FlexProfessionalsCreateEmployeeContactInfo from './FlexProfessionalsCreateEmployeeContactInfo';
import FlexProfessionalsEditEmployee from './FlexProfessionalsEditEmployee';
import { PencilIcon } from '../../../components/icons';

const FlexProfessionalsCreate = () => {
	const [editMode] = useState(false);
	const [showEditIcon] = useState(false);
	const location = useLocation();
	const history = useHistory();
	const { managementCompanyId } = useParams();
	const userData = useSelector(user, shallowEqual);

	const createPath = `${PRIVATE_PATH.WORKFORCE_PAGE}/${managementCompanyId}/professionals/create`;

	const managementCompanyPermissions = userData.managementCompanyPermissions[managementCompanyId];
	const canPreviewCredentialsStep =
		utils.isAuthorizedExact(PERMISSION.WORKFORCE_CREDENTIALS_VIEW, managementCompanyPermissions) &&
		utils.isAuthorizedExact(PERMISSION.WORKFORCE_CREDENTIALS_EDIT, managementCompanyPermissions);

	const sidebarItems = [
		{
			label: 'Employee Details',
			editTitle: 'Add Professional',
			isEditing: true,
			path: location.pathname,
			additionalAction: showEditIcon && !editMode && (
				<button className="edit-contact" type="button">
					<PencilIcon />
					Edit
				</button>
			),
			editText: 'Add Professional',
			className: 'details-header'
		},
		...(canPreviewCredentialsStep
			? [
					{
						label: 'Credentials',
						editTitle: `Credentials`,
						isEditing: true,
						path: null,
						className: 'credentials-header',
						isDisabled: true
					}
			  ]
			: [])
	];

	const handleBackToWorkforce = () => {
		history.push(PRIVATE_PATH.WORKFORCE_PAGE);
	};

	const handleNavigateToNextStep = (state) => {
		const values = {
			data: {
				email: state.data.email,
				phone: state.data.phone_number
			},
			notification: state.notification
		};
		history.push(`${createPath}/contact-information`, values);
	};

	return (
		<SidebarWrapper
			sidebarTitle="Manage Professional"
			sidebarItems={sidebarItems}
			backTitle="Back to Workforce"
			backAction={handleBackToWorkforce}
		>
			<Switch>
				<Route exact path={createPath}>
					<FlexProfessionalsCreateEmployeeContactInfo
						managementCompanyId={managementCompanyId}
						handleNavigateToNextStep={handleNavigateToNextStep}
					/>
				</Route>
				<Route
					exact
					path={`${createPath}/contact-information`}
					render={(props) =>
						props.location.state ? (
							<FlexProfessionalsEditEmployee managementCompanyId={managementCompanyId} />
						) : (
							<Redirect to={createPath} />
						)
					}
				/>
				<Route path="/*" render={() => <Redirect to="/404" />} />
			</Switch>
		</SidebarWrapper>
	);
};

export default FlexProfessionalsCreate;
